import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-notification-modal',
  templateUrl: './notification-modal.component.html',
  styleUrls: ['./notification-modal.component.scss'],
})
export class NotificationModalComponent {
  icon: string;
  message: string;
  showButton: boolean;
  buttonText: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<NotificationModalComponent>
  ) {
    this.icon = data.icon;
    this.message = data.message;
    this.showButton = data.showButton !== undefined ? data.showButton : false;
    this.buttonText = data.buttonText || 'OK';
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
